// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { VOBaseAttribute } from './VOBaseAttribute';
import { BEAttribute } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { EnumSearchStyle } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumSearchStyle';
import { EnumAlignStyle } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumAlignStyle';
import { EnumSortStyle } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumSortStyle';
import { ViewObject } from './ViewObject';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 实体视图属性 实体类
 * 实体视图属性
 */
export class EVOAttribute extends VOBaseAttribute {
  /** 是否可查询 : 是否可查询 */
  private _isSearch: boolean;

  /** 设置：是否可查询 */
  public get isSearch() {
    return this._isSearch;
  }

  /** 获取：是否可查询 */
  public set isSearch(value: boolean) {
    this._isSearch = value;
  }

  /** 查询方式 : 设定查询方式，根据数据类型设置 */
  private _searchStyle: EnumSearchStyle;

  /** 设置：查询方式 */
  public get searchStyle() {
    return this._searchStyle;
  }

  /** 获取：查询方式 */
  public set searchStyle(value: EnumSearchStyle) {
    this._searchStyle = value;
  }

  /** 是否在列表 : 是否在列表中呈现 */
  private _isInList: boolean;

  /** 设置：是否在列表 */
  public get isInList() {
    return this._isInList;
  }

  /** 获取：是否在列表 */
  public set isInList(value: boolean) {
    this._isInList = value;
  }

  /** 对齐方式 : 列表中的对齐方式，默认根据数据类型设置 */
  private _alignStyle: EnumAlignStyle;

  /** 设置：对齐方式 */
  public get alignStyle() {
    return this._alignStyle;
  }

  /** 获取：对齐方式 */
  public set alignStyle(value: EnumAlignStyle) {
    this._alignStyle = value;
  }

  /** 是否冻结 : 是否冻结，true代表冻结，冻结列在列表中的最前面，不受排序影响 */
  private _isFrozen: boolean;

  /** 设置：是否冻结 */
  public get isFrozen() {
    return this._isFrozen;
  }

  /** 获取：是否冻结 */
  public set isFrozen(value: boolean) {
    this._isFrozen = value;
  }

  /** 列宽 : 默认列宽，0代表自适应 */
  private _columnWidth: number;

  /** 设置：列宽 */
  public get columnWidth() {
    return this._columnWidth;
  }

  /** 获取：列宽 */
  public set columnWidth(value: number) {
    this._columnWidth = value;
  }

  /** 是否缺省排序 : 是否缺省排序属性 */
  private _isDefaultSort: boolean;

  /** 设置：是否缺省排序 */
  public get isDefaultSort() {
    return this._isDefaultSort;
  }

  /** 获取：是否缺省排序 */
  public set isDefaultSort(value: boolean) {
    this._isDefaultSort = value;
  }

  /** 缺省排序方式 : 缺省排序方式，当设置为缺省排序属性时有效 */
  private _defaultSortStyle: EnumSortStyle;

  /** 设置：缺省排序方式 */
  public get defaultSortStyle() {
    return this._defaultSortStyle;
  }

  /** 获取：缺省排序方式 */
  public set defaultSortStyle(value: EnumSortStyle) {
    this._defaultSortStyle = value;
  }

  /** 是否可排序 : 是否可排序，不可排序属性不能在列表列头点击进行排序 */
  private _isSortable: boolean;

  /** 设置：是否可排序 */
  public get isSortable() {
    return this._isSortable;
  }

  /** 获取：是否可排序 */
  public set isSortable(value: boolean) {
    this._isSortable = value;
  }

  /** 是否在参照列表 : 是否在参照列表中，只有参照是列表呈现的时候有效 */
  private _isInRefList: boolean;

  /** 设置：是否在参照列表 */
  public get isInRefList() {
    return this._isInRefList;
  }

  /** 获取：是否在参照列表 */
  public set isInRefList(value: boolean) {
    this._isInRefList = value;
  }

  /** 是否查询属性 : 是否是参照的查询属性，多个属性的时候用or连接 */
  private _isRefSearch: boolean;

  /** 设置：是否查询属性 */
  public get isRefSearch() {
    return this._isRefSearch;
  }

  /** 获取：是否查询属性 */
  public set isRefSearch(value: boolean) {
    this._isRefSearch = value;
  }

  /** 允许新建 : 创建对象的时候，首次可以录入 */
  private _canCreate: boolean;

  /** 设置：允许新建 */
  public get canCreate() {
    return this._canCreate;
  }

  /** 获取：允许新建 */
  public set canCreate(value: boolean) {
    this._canCreate = value;
  }

  /** 允许修改 : 已经持久化的实体属性，可以再次修改 */
  private _canEdit: boolean;

  /** 设置：允许修改 */
  public get canEdit() {
    return this._canEdit;
  }

  /** 获取：允许修改 */
  public set canEdit(value: boolean) {
    this._canEdit = value;
  }

  /** 详情内是否可见 : 属性是否在详情中呈现，false则在详情内不可见 */
  private _isInDetail: boolean;

  /** 设置：详情内是否可见 */
  public get isInDetail() {
    return this._isInDetail;
  }

  /** 获取：详情内是否可见 */
  public set isInDetail(value: boolean) {
    this._isInDetail = value;
  }

  /** 是否同步 : 是否同步，true代表显示名称、简介信息与实体同步，否则属于自定义 */
  private _isSync: boolean;

  /** 设置：是否同步 */
  public get isSync() {
    return this._isSync;
  }

  /** 获取：是否同步 */
  public set isSync(value: boolean) {
    this._isSync = value;
  }

  /** 已移除 : 已移除的属性前端不可用 */
  private _removed: boolean;

  /** 设置：已移除 */
  public get removed() {
    return this._removed;
  }

  /** 获取：已移除 */
  public set removed(value: boolean) {
    this._removed = value;
  }

  /** 绑定实体属性 的ID */
  private _bindingBEAttribute_ID: string;

  /** 获取：绑定实体属性 的ID */
  public get bindingBEAttribute_ID() {
    return this._bindingBEAttribute_ID;
  }

  /** 设置：绑定实体属性 的ID */
  public set bindingBEAttribute_ID(value: string) {
    this._bindingBEAttribute_ID = value;
  }

  /** 绑定实体属性  */
  private _bindingBEAttribute: BEAttribute;

  /** 获取：绑定实体属性  */
  public get bindingBEAttribute() {
    return this._bindingBEAttribute;
  }

  /** 设置：绑定实体属性  */
  public set bindingBEAttribute(value: BEAttribute) {
    this._bindingBEAttribute = value;
    if (value !== null) {
      this.bindingBEAttribute_ID = value.id;
    } else {
      this.bindingBEAttribute_ID = '';
    }
  }

  /** 视图对象 的ID */
  private _viewObject_ID: string;

  /** 获取：视图对象 的ID */
  public get viewObject_ID() {
    return this._viewObject_ID;
  }

  /** 设置：视图对象 的ID */
  public set viewObject_ID(value: string) {
    this._viewObject_ID = value;
  }

  /** 视图对象  */
  private _viewObject: ViewObject;

  /** 获取：视图对象  */
  public get viewObject() {
    return this._viewObject;
  }

  /** 设置：视图对象  */
  public set viewObject(value: ViewObject) {
    this._viewObject = value;
    if (value !== null) {
      this.viewObject_ID = value.id;
    } else {
      this.viewObject_ID = '';
    }
  }

  constructor() {
    super();
    this._isSearch = true;
    this._searchStyle = EnumSearchStyle.Equal;
    this._isInList = true;
    this._alignStyle = EnumAlignStyle.Center;
    this._isFrozen = false;
    this._columnWidth = 0;
    this._isDefaultSort = false;
    this._defaultSortStyle = EnumSortStyle.Asc;
    this._isSortable = false;
    this._isInRefList = false;
    this._isRefSearch = false;
    this._canCreate = true;
    this._canEdit = true;
    this._isInDetail = true;
    this._isSync = true;
    this._removed = false;
    this._bindingBEAttribute_ID = '';
    this._bindingBEAttribute = null;
    this._viewObject_ID = '';
    this._viewObject = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: EVOAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isSearch = element.isSearch;
      this.searchStyle = element.searchStyle;
      this.isInList = element.isInList;
      this.alignStyle = element.alignStyle;
      this.isFrozen = element.isFrozen;
      this.columnWidth = element.columnWidth;
      this.isDefaultSort = element.isDefaultSort;
      this.defaultSortStyle = element.defaultSortStyle;
      this.isSortable = element.isSortable;
      this.isInRefList = element.isInRefList;
      this.isRefSearch = element.isRefSearch;
      this.canCreate = element.canCreate;
      this.canEdit = element.canEdit;
      this.isInDetail = element.isInDetail;
      this.isSync = element.isSync;
      this.removed = element.removed;
      this.bindingBEAttribute_ID = element.bindingBEAttribute_ID;
      if (hasReference && element.bindingBEAttribute !== null) {
        this.bindingBEAttribute = element.bindingBEAttribute;
      }
      this.viewObject_ID = element.viewObject_ID;
      if (hasReference && element.viewObject !== null) {
        this.viewObject = element.viewObject;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isSearch = json.IsSearch;
    this.searchStyle = json.SearchStyle as EnumSearchStyle;
    this.isInList = json.IsInList;
    this.alignStyle = json.AlignStyle as EnumAlignStyle;
    this.isFrozen = json.IsFrozen;
    this.columnWidth = json.ColumnWidth;
    this.isDefaultSort = json.IsDefaultSort;
    this.defaultSortStyle = json.DefaultSortStyle as EnumSortStyle;
    this.isSortable = json.IsSortable;
    this.isInRefList = json.IsInRefList;
    this.isRefSearch = json.IsRefSearch;
    this.canCreate = json.CanCreate;
    this.canEdit = json.CanEdit;
    this.isInDetail = json.IsInDetail;
    this.isSync = json.IsSync;
    this.removed = json.Removed;
    this.bindingBEAttribute_ID = json.BindingBEAttribute_ID;
    // if (json.BindingBEAttribute !== null) {
    //   this.bindingBEAttribute = BEAttribute.Create(json.BindingBEAttribute);
    // }
    this.viewObject_ID = json.ViewObject_ID;
    // if (json.ViewObject !== null) {
    //   this.viewObject = ViewObject.Create(json.ViewObject);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsSearch = this.isSearch;
    json.SearchStyle = this.searchStyle;
    json.IsInList = this.isInList;
    json.AlignStyle = this.alignStyle;
    json.IsFrozen = this.isFrozen;
    json.ColumnWidth = this.columnWidth;
    json.IsDefaultSort = this.isDefaultSort;
    json.DefaultSortStyle = this.defaultSortStyle;
    json.IsSortable = this.isSortable;
    json.IsInRefList = this.isInRefList;
    json.IsRefSearch = this.isRefSearch;
    json.CanCreate = this.canCreate;
    json.CanEdit = this.canEdit;
    json.IsInDetail = this.isInDetail;
    json.IsSync = this.isSync;
    json.Removed = this.removed;
    json.BindingBEAttribute_ID = this.bindingBEAttribute_ID;
    json.ViewObject_ID = this.viewObject_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('查询设置', 'isSearch', '是否可查询', EnumDataType.Bool, this.isSearch, true, '是否可查询', '', '');
    context.addRow('查询设置', 'searchStyle', '查询方式', EnumDataType.Reference, this.searchStyle, true, '设定查询方式，根据数据类型设置', 'EnumSearchStyle', 'PGRowEnumValue');
    context.addRow('列表设置', 'isInList', '是否在列表', EnumDataType.Bool, this.isInList, true, '是否在列表中呈现', '', '');
    context.addRow('列表设置', 'alignStyle', '对齐方式', EnumDataType.Reference, this.alignStyle, true, '列表中的对齐方式，默认根据数据类型设置', 'EnumAlignStyle', 'PGRowEnumValue');
    context.addRow('列表设置', 'isFrozen', '是否冻结', EnumDataType.Bool, this.isFrozen, true, '是否冻结，true代表冻结，冻结列在列表中的最前面，不受排序影响', '', '');
    context.addRow('列表设置', 'columnWidth', '列宽', EnumDataType.Int, this.columnWidth, true, '默认列宽，0代表自适应', '', '');
    context.addRow('列表设置', 'isDefaultSort', '是否缺省排序', EnumDataType.Bool, this.isDefaultSort, true, '是否缺省排序属性', '', '');
    context.addRow('列表设置', 'defaultSortStyle', '缺省排序方式', EnumDataType.Reference, this.defaultSortStyle, true, '缺省排序方式，当设置为缺省排序属性时有效', 'EnumSortStyle', 'PGRowEnumValue');
    context.addRow('列表设置', 'isSortable', '是否可排序', EnumDataType.Bool, this.isSortable, true, '是否可排序，不可排序属性不能在列表列头点击进行排序', '', '');
    context.addRow('参照设置', 'isInRefList', '是否在参照列表', EnumDataType.Bool, this.isInRefList, true, '是否在参照列表中，只有参照是列表呈现的时候有效', '', '');
    context.addRow('参照设置', 'isRefSearch', '是否查询属性', EnumDataType.Bool, this.isRefSearch, true, '是否是参照的查询属性，多个属性的时候用or连接', '', '');
    context.addRow('编辑属性', 'canCreate', '允许新建', EnumDataType.Bool, this.canCreate, true, '创建对象的时候，首次可以录入', '', '');
    context.addRow('编辑属性', 'canEdit', '允许修改', EnumDataType.Bool, this.canEdit, true, '已经持久化的实体属性，可以再次修改', '', '');
    context.addRow('详情设置', 'isInDetail', '详情内是否可见', EnumDataType.Bool, this.isInDetail, true, '属性是否在详情中呈现，false则在详情内不可见', '', '');
    context.addRow('绑定设置', 'isSync', '是否同步', EnumDataType.Bool, this.isSync, true, '是否同步，true代表显示名称、简介信息与实体同步，否则属于自定义', '', '');
    context.addRow('绑定设置', 'bindingBEAttribute', '绑定实体属性', EnumDataType.Reference, this.bindingBEAttribute, false, '绑定的业务实体属性', 'BEAttribute', 'PGRowBindingBEAttributeValue');
    return context;
  }

  static Create(json: any): EVOAttribute {
    const eVOAttribute = new EVOAttribute();
    eVOAttribute.Deserialize(json);
    eVOAttribute.json = json;
    return eVOAttribute;
  }
}
